import Api from '@/api';
// import Cookies from 'js-cookie';
// import md5 from 'js-md5'

const productFilter = {
    state: {
        searchProductId:'',
        company: '',
        productType: '',
    },

    mutations: {
        SET_SEARCH_PRODUCT_ID: (state, data) => {
            state.searchProductId = data;
        },
        SET_COMPANY: (state, data) => {
            state.company = data;
        },
        SET_PRODUCT_TYPE: (state, data) => {
            state.productType = data;
        }
    },

    actions: {

        kobe({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                Api.login(params).then(response => {
                    commit('SET_USER_INFO', response.data);
                    commit('SET_LOGIN_MODAL', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_USER_INFO');
                    reject(error);
                });
            });
        },
    }
};

export default productFilter;



// WEBPACK FOOTER //
// ./src/store/modules/productFilter.js